import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
    const token = sessionStorage.getItem("token");
    return token ? <Navigate to="/dashboard" /> : element;
};

export default ProtectedRoute;